<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
/**
 * Products component
 */
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      logoUrl: (process.env.BASE_URL || "/") + "logo.jpeg",
      userT : this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
      formPro: {
        direccionp: "",
        empleado: "",
        nit_cliente: "",
        no_orden: "",
        observaciones: "",
        fecha_compra: "",
        tienda: "",
        cliente: "",
        dias_vencimiento: "",
        total: "",
        state: true,
        id: 0,
      },
      detalleorden: [],
      title: "IMPRIMIR",
      items: [
        {
          text: "Cotización",
          href: "/",
        },
        {
          text: "Imprimir cotización",
          active: true,
        },
      ],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMMM DD [de] YYYY");
    },
    detalle() {
      let me = this;
      axios
        .get(
          process.env.VUE_APP_URL +
            "cotizaciones/view_cotizacion?id=" +
            this.$route.params.id,{
            headers: { "x-token": this.userT.token}
          }
        )
        .then((response) => {
          // console.log("response", response);

          this.formPro.cliente =
            response.data.orden.cliente_rapido != ""
              ? response.data.orden.cliente_rapido
              : response.data.orden.cliente.persona.nombre_persona;
          this.formPro.total = response.data.orden.total;
          this.formPro.dias_vencimiento = response.data.orden.dias_vencimiento;
          this.formPro.no_orden = response.data.orden.no_cotizacion;

          let detalleProducto = response.data.orden.detalle_cotizaciones;
          let detalleServicio = response.data.orden.detalle_servicios;
           console.log('detalle Prod',detalleProducto);
          // console.log(detalleServicio);

          for (let i = 0; i < detalleProducto.length; i++) {
            me.detalleorden.push({
              cantidad: detalleProducto[i].cantidad_venta,
              descripcion:
                detalleProducto[i].stock.producto.nombre_producto +
                (detalleProducto[i].stock.producto.descripcion_producto ==
                  null ||
                detalleProducto[i].stock.producto.descripcion_producto == ""
                  ? ""
                  : " - " +
                    detalleProducto[i].stock.producto.descripcion_producto),
              valor_unitario: detalleProducto[i].precio_venta,
              precio_venta: detalleProducto[i].precio_original,
              subtotal: detalleProducto[i].subtotal_venta,
            });
          }

          for (let i = 0; i < detalleServicio.length; i++) {
            me.detalleorden.push({
              cantidad: detalleServicio[i].cantidad_servicios,
              descripcion:
                detalleServicio[i].servicio.nombre_servicio +
                (detalleServicio[i].servicio.descripcion_servicio == "" ||
                detalleServicio[i].servicio.descripcion_servicio == null
                  ? ""
                  : " - " + detalleServicio[i].servicio.descripcion_servicio),
              valor_unitario: detalleServicio[i].precio_servicio,
              subtotal: detalleServicio[i].subtotal_servicio,
            });
          }
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
  /**
   * Total no. of records
   */

  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="d-print-none" />

    <!-- Botones -->
    <div class="row mt-4 d-print-none">
      <div class="col">
        <router-link
          :to="{ name: 'Cotizacion' }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col">
        <div class="float-end">
          <a
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a>
        </div>
      </div>
    </div>

    <!-- Cotización -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body doc">
            <!-- Header corporativo -->
            <div class="doc-header">
              <div class="doc-brand">
                <img :src="logoUrl" alt="Logo" class="doc-logo" />
                <div>
                  <div class="doc-name">Repuestos Ariel GT</div>
                  <div class="doc-tag">Comapa, Jutiapa · Tel 3453</div>
                </div>
              </div>
              <div class="doc-meta">
                <div class="doc-badge">COTIZACIÓN</div>
                <div class="doc-no">No. {{ this.formPro.no_orden }}</div>
                <div class="doc-date">Guatemala, {{ showDate(new Date()) }}</div>
              </div>
            </div>

            <!-- Destinatario -->
            <div class="doc-to">
              <span class="doc-to-label">Señor(a)</span>
              <span class="doc-to-name">{{ this.formPro.cliente }}</span>
              <span class="doc-to-city">Ciudad</span>
            </div>

            <p class="doc-intro">
              En atención a su solicitud, nos permitimos cotizar los siguientes
              artículos:
            </p>

            <table class="doc-table">
              <thead>
                <tr>
                  <th class="c">Cantidad</th>
                  <th>Descripción</th>
                  <th class="r">V. unitario s/desc.</th>
                  <th class="r">V. unitario c/desc.</th>
                  <th class="r">Valor total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in detalleorden" v-bind:key="idx">
                  <td class="c">{{ item.cantidad }}</td>
                  <td>{{ item.descripcion }}</td>
                  <td class="r">{{ item.precio_venta ? money(item.precio_venta) : money(item.valor_unitario) }}</td>
                  <td class="r">{{ money(item.valor_unitario) }}</td>
                  <td class="r">{{ money(item.subtotal) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3"></td>
                  <td class="r">TOTAL INCLUIDO IVA 16%</td>
                  <td class="r">{{ money(formPro.total > 0 ? formPro.total : 0.0) }}</td>
                </tr>
              </tfoot>
            </table>

            <div class="doc-notes">
              <p>
                <strong>Vigencia de la cotización:</strong>
                {{ formPro.dias_vencimiento }} días
              </p>
              <p><strong>*Esta mercancía cuenta con garantía de fábrica.</strong></p>
              <p>
                En espera que nuestra cotización sea de su total satisfacción y poder
                atender sus pedidos.
              </p>
            </div>

            <div class="doc-footer">Repuestos Ariel GT · Comapa, Jutiapa</div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.doc { color: #2b2f3a; font-size: 13px; }

.doc-header {
  display: flex; align-items: center; justify-content: space-between;
  border-bottom: 4px solid #1b2a4e; padding-bottom: 16px; margin-bottom: 20px;
}
.doc-brand { display: flex; align-items: center; gap: 16px; }
.doc-logo { height: 76px; width: auto; object-fit: contain; border-radius: 8px; }
.doc-name { font-size: 24px; font-weight: 800; color: #1b2a4e; }
.doc-tag { font-size: 12px; color: #6b7280; }
.doc-meta { text-align: right; }
.doc-badge {
  background: #1b2a4e; color: #fff; font-weight: 700; font-size: 14px;
  padding: 6px 16px; border-radius: 4px; letter-spacing: 1px; display: inline-block;
}
.doc-no { font-size: 18px; font-weight: 800; color: #c5a253; margin-top: 6px; }
.doc-date { font-size: 12px; color: #6b7280; }

.doc-to {
  display: flex; flex-direction: column; gap: 2px;
  background: #f7f9fc; border: 1px solid #e7e9ef; border-radius: 8px;
  padding: 12px 18px; margin-bottom: 14px;
}
.doc-to-label { font-size: 10px; color: #8a909c; text-transform: uppercase; letter-spacing: .5px; }
.doc-to-name { font-size: 16px; font-weight: 700; color: #1b2a4e; }
.doc-to-city { font-size: 12px; color: #6b7280; }

.doc-intro { margin-bottom: 12px; }

.doc-table { width: 100%; border-collapse: collapse; }
.doc-table thead th {
  background: #1b2a4e; color: #fff; font-size: 10px; font-weight: 600;
  text-transform: uppercase; padding: 9px 8px; text-align: left;
}
.doc-table tbody td { padding: 8px; border-bottom: 1px solid #eef0f4; font-size: 12px; }
.doc-table tbody tr:nth-child(even) { background: #f9fafc; }
.doc-table tfoot td {
  padding: 10px 8px; font-weight: 700; color: #1b2a4e; background: #eef1f7; font-size: 13px;
}
.doc-table .r { text-align: right; }
.doc-table .c { text-align: center; }

.doc-notes { margin-top: 16px; font-size: 13px; }
.doc-notes p { margin: 4px 0; }
.doc-footer {
  margin-top: 26px; text-align: center; color: #8a909c; font-size: 11px;
  border-top: 1px solid #e7e9ef; padding-top: 10px;
}

@media print {
  .doc, .doc * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
</style>
